import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getMovementEncaissement } from "../../context/movementContext/apiCalls";
import ErrorComponent from "../../components/errorComponent/ErrorComponent";
import LoadingComponent from "../../components/loadingComponent/LoadingComponent";
import AdminSideBar from "../../components/adminSideBar/AdminSideBar";
import { MovementContext } from "../../context/movementContext/MovementContext";
import { typeActionsEnvois, typeDeliveries, typeEnvois, typeRamassages, wilayas } from "../../data";
import PageSizeComponent from "../../components/pageSizeComponent/PageSizeComponent";
import TableComponent from "../../components/tableComponent/TableComponent";
import PaginationComponent from "../../components/paginationComponent/PaginationComponent";


export default function DetailEncaissement() {
    const { page = 1, id } = useParams();
    const [pageSize, setPageSize] = useState(10);

    const { dispatch, movementEncaissement, envoisEncaissement, count: pages, isFetchingGetEncaissement, errorGetEncaissement, } = useContext(MovementContext);

    useEffect(() => {
        getMovementEncaissement(dispatch, pageSize, page, id);
    }, [id, pageSize, page])

    function getEnvoieMoney(movement, envoie) {
        let res = 0;
        if (movement.typeAction === 8 || movement.typeAction === 2) {
            if (envoie.typeEnvoie === 3) {
                res = envoie.montant;
            } else {
                if (!envoie.Entreprise) {
                    res = envoie.cost;
                } else {
                    res = 0;
                }
            }
        } else if (movement.typeAction === 5 || movement.typeAction === 6) {
            if (envoie.typeEnvoie === 3) {
                if (!envoie.Entreprise) {
                    res = envoie.cost;
                } else {
                    res = 0;
                }
            } else {
                res = envoie.montant;
            }
        }
        return res * 1;
    }
    const getTypeDelivery = (type) => {
        if (type === 1) {
            return "a-domicile"
        } else if (type === 2) {
            return "en-agence"
        }
    }
    const getTypeEnvoie = (type) => {
        if (type === 1) {
            return "a-accuse"
        } else if (type === 2) {
            return "s-accuse"
        } else if (type === 3) {
            return "pick-up"
        }
    }

    return (
        <div className='container-global'>
            <AdminSideBar activeTab="movement" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>
                        Detail Encaissement : {" "}
                        {movementEncaissement.typeAction ? typeActionsEnvois.filter(item => item.id === movementEncaissement.typeAction)[0]['nom'] : "Réception Agence"}
                    </span>
                </div>

                {
                    errorGetEncaissement ? <ErrorComponent error={errorGetEncaissement} /> : (
                        isFetchingGetEncaissement ? <LoadingComponent /> : (
                            envoisEncaissement.length === 0 ? <span className='no-data'>Il n'y a pas de données</span>
                                : (
                                    <>
                                        <PageSizeComponent pageSize={pageSize} setPageSize={setPageSize} itemLocation={`movements/encaisse/${id}/detail`} />
                                        <div className="content">
                                            <>
                                                <TableComponent headers={['Id', "Expéditeur", "Type d'Envoie", "Type Dépot", "Type Livraison", "Wilaya Départ", "Wilaya d'Arrivé", "Argent", 'Date']}>
                                                    {
                                                        envoisEncaissement.map((envoie, index) => (
                                                            <tr key={index}>
                                                                <td>{envoie.id} </td>
                                                                <td>{envoie.EntrepriseId ? envoie.Entreprise.nom : envoie.User.username}</td>
                                                                <td>
                                                                    <span className={`table-special-border ${getTypeEnvoie(envoie.typeEnvoie)}`}>{typeEnvois.filter(item => item.id === envoie.typeEnvoie)[0]['nom']}</span>
                                                                </td>
                                                                <td>
                                                                    <span className={`table-special ${getTypeDelivery(envoie.typeRamassage)}`}>{typeRamassages.filter(item => item.id === envoie.typeRamassage)[0]['nom'].slice(6)}</span>
                                                                </td>
                                                                <td>
                                                                    <span className={`table-special ${getTypeDelivery(envoie.typeDelivery)}`}>{typeDeliveries.filter(item => item.id === envoie.typeDelivery)[0]['nom'].slice(10)}</span>
                                                                </td>
                                                                <td>{wilayas.filter(item => item.id == envoie.wilayaDeparture)[0]['nom']}</td>
                                                                <td>{wilayas.filter(item => item.id == envoie.wilayaArrived)[0]['nom']}</td>
                                                                <td>{(getEnvoieMoney(movementEncaissement, envoie)).toFixed(2)}</td>
                                                                <td>{envoie.createdAt.slice(0, 10)}</td>
                                                            </tr>
                                                        ))
                                                    }
                                                </TableComponent>
                                                {
                                                    (pages > 1) && (<PaginationComponent page={page} pages={pages} item={`movements/encaisse/${id}/detail`} />)
                                                }
                                            </>
                                        </div>
                                    </>
                                )
                        )
                    )
                }
            </div>
        </div>
    )
}